import type { ComponentType } from "react";
import { DIALOGS, type DialogType } from "@/types";
import {
    LockTransaction as LockTransactionDialog,
    LockFormDialog,
    MintTransaction,
    DepositTransactionDialog,
    RedeemTransaction,
    RedeemFormDialog,
    RedeemFormDialogAlt,
    DepositMoreFormDialog,
    WithdrawFormDialog,
    WithdrawTransaction,
    LockMoreFormDialog,
    ChangeDurationFormDialog,
    WithdrawLockFormDialog,
    WithdrawLockTransaction,
    ChangeDurationTransaction,
    CancelExitTransaction,
    ClaimRedemption,
    WithdrawUnwoundTransaction,
    JoinWaitlistDialog,
    VoteSubmitDialog,
    VoteSuccessToast,
    WaitlistInterceptorDialog,
} from "@/components";
import { WhaleRetentionDialog } from "@/components/dialogs/WhaleRetentionDialog/WhaleRetentionDialog";
import { AdblockerDetectedDialog } from "@/components/dialogs/AdblockerDetectedDialog";
import { ExitLockFeedbackDialog } from "@/components/dialogs/ExitLock/ExitLockFeedbackDialog";
import { ExitLockWhaleRetainDialog } from "@/components/dialogs/ExitLock/WhaleRetain/ExitLockWhaleRetainDialog";
import { ReallocatePointsDialog } from "@/components/dialogs/PointsReallocateDialog";
import { PointsNewChapterDialog } from "@/components/dialogs/PointsNewChapterDialog";

export const DIALOG_COMPONENTS: Record<DialogType, ComponentType> = {
    [DIALOGS.LOCK_FORM]: LockFormDialog,
    [DIALOGS.LOCK_MORE_FORM]: LockMoreFormDialog,
    [DIALOGS.MINT_CONFIRM]: MintTransaction,
    [DIALOGS.LOCK_CONFIRM]: LockTransactionDialog,
    [DIALOGS.DEPOSIT_CONFIRM]: DepositTransactionDialog,
    [DIALOGS.REDEEM_CONFIRM]: RedeemTransaction,
    [DIALOGS.REDEEM_FORM]: RedeemFormDialog,
    [DIALOGS.REDEEM_FORM_ALT]: RedeemFormDialogAlt,
    [DIALOGS.DEPOSIT_MORE_FORM]: DepositMoreFormDialog,
    [DIALOGS.WITHDRAW_FORM]: WithdrawFormDialog,
    [DIALOGS.WITHDRAW_CONFIRM]: WithdrawTransaction,
    [DIALOGS.CHANGE_DURATION_FORM]: ChangeDurationFormDialog,
    [DIALOGS.CHANGE_DURATION_CONFIRM]: ChangeDurationTransaction,
    [DIALOGS.WITHDRAW_LOCK_FORM]: WithdrawLockFormDialog,
    [DIALOGS.WITHDRAW_LOCK_CONFIRM]: WithdrawLockTransaction,
    [DIALOGS.REALLOCATE_POINTS]: ReallocatePointsDialog,
    [DIALOGS.CANCEL_EXIT_CONFIRM]: CancelExitTransaction,
    [DIALOGS.CLAIM_CONFIRM]: ClaimRedemption,
    [DIALOGS.WITHDRAW_UNWOUND_CONFIRM]: WithdrawUnwoundTransaction,
    [DIALOGS.JOIN_WAITLIST]: JoinWaitlistDialog,
    [DIALOGS.WAITLIST_INTERCEPTOR]: WaitlistInterceptorDialog,
    [DIALOGS.VOTE_SUBMIT]: VoteSubmitDialog,
    [DIALOGS.VOTE_SUCCESS]: VoteSuccessToast,
    [DIALOGS.WHALE_RETENTION]: WhaleRetentionDialog,
    [DIALOGS.ADBLOCKER_DETECTED]: AdblockerDetectedDialog,
    [DIALOGS.EXIT_FEEDBACK]: ExitLockFeedbackDialog,
    [DIALOGS.EXIT_RETAIN_WHALE]: ExitLockWhaleRetainDialog,
    [DIALOGS.POINTS_NEW_CHAPTER]: PointsNewChapterDialog,
};
